
















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import resize from 'vue-resize-directive';
import * as Components from '@/agiles/components';

@Component({
  directives: {
    resize,
  },
})
export default class Grid extends Vue {
  // 初期データはインスタンスプロパティとして宣言できます
  @Prop() public items?: any[];
  @Prop({ default: false }) public isLoading: boolean;
  @Prop({ default: false }) public showCheckBox: boolean;
  @Prop({ default: null }) public height: number;
  @Prop({ default: null }) public width: number;

  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: null }) public visibles: Array<boolean>; 

  @Prop({ default: '' }) public storageKey: string;
  @Prop({ default: false }) public isDescending: boolean;
  @Prop({ default: '' }) public sortCaption: string;
  @Prop({ default: false }) public sortEnabled: boolean;
  @Prop({ default: null }) public sortCaptions: Array<string>;
  @Prop({ default: 34 }) public rowHeight: number;
  @Prop({ default: true }) public showGearButton: boolean;
  @Prop({ default: false }) public highlight: boolean;
  @Prop({ default: false }) public autoselect: boolean; //1行目の自動選択

  private columns: Array<{ caption: string; width: number; position: number; slot: number; sortable: boolean }> = new Array(); //キャプションと表示幅を表示順に保持する(匿名オブジェクト)
  public get visibleItems() {
    return this.items; //.slice(this.fromIndex, this.toIndex);
  }

  public allChecked :boolean = false;
  public checked: boolean[] = new Array(0);
  public selectedId: number = -1;

  /**フォーカス状態: スタイルにfocusクラスを付与します */
  public hasFocus: boolean = false;

  public hasVerticalScrollbar = false;
  /**フォーカスハンドラ */
  public onFocus(e: any) {
    if (this.$el.contains(e.srcElement)) this.hasFocus = true;
    else this.hasFocus = false;
  }

  public created() {
    //ListBoxの内部要素にFocusがあるかどうかを検証するハンドラを配置します。
    document.body.addEventListener('focusin', this.onFocus, { capture: true });
    document.body.addEventListener('mouseup', this.onMouseUp, { capture: false });
    document.body.addEventListener('touchend', this.onMouseUp, { capture: false });
    this.loadColumns();


  }

  public destroyed() {
    document.body.removeEventListener('focusin', this.onFocus, { capture: true });
    document.body.removeEventListener('mouseup', this.onMouseUp, { capture: false });
    document.body.removeEventListener('touchend', this.onMouseUp, { capture: false });


  }

  /**リストをフォーカス状態にします。 */
  public focus() {
    (this.$refs.listView as HTMLElement).focus();
  }

  public mounted() {
    // this.setPaddingWidth();
    // this.computeVisbleIndex();
    this.onValueChange(this.items,null);
    let observer = new IntersectionObserver(this.computeVisbleIndex, null);
    observer.observe(this.$refs.listView as HTMLElement);    
  }
  public get defaultRowCount(){
    var elm = this.$refs.listView as HTMLElement;
    return Math.ceil(elm.clientHeight / this.rowHeight);
  }
  public get tableWidth():string {
    var total = 0;
    if (this.showCheckBox) total += 50;
    this.columns.forEach(obj => total += obj.width);
    total += 40; //ギアアイコン
    return total + 'px';
  }
  public get tableWidth2():string {
    //縦スクロールバーが表示されている場合、横幅を短くする(ヘッダが連動しなくなるため)
    var total = 0;
    if (this.showCheckBox) total += 50;
    this.columns.forEach(obj => total += obj.width);
    total += 50; //ギアアイコン
    //total -= 17; //縦スクロールバー分の領域を狭くする
    var el = this.$refs.listView as HTMLElement;
    if (el.offsetWidth - el.clientWidth > 0) total -=17; //スクロールバーの幅は17px固定(clientWidthが正しく計算されていない?)。携帯の場合はゼロ
    return total + 'px';
  }
  /**高さを設定します。 */
  public get defaultStyle(): string {
    return (this.height == null ? '' : 'height:' + this.height + 'px;overflow-y:auto;flex:none;') + (this.width ? 'width:' + this.width +'px;':'' );
  }
  @Watch('allChecked')
  public onAllCheckedChanged(newValue: boolean, oldValue: boolean){
    // this.items.forEach((obj, index) => {if(index != this.selectedId)this.checked[index] = newValue;});        
    this.items.forEach((obj, index) => {this.checked[index] = newValue;});    
    //チェック状態に移行する場合は、アクティブ行をセット
    if (newValue && this.selectedId == -1 && this.items.length > 0) this.onCardClicked(0);
    //チェックオフ時にリセットする
    else if (newValue == false) this.selectedId = -1;

  }
  public stopPropagation(arg : Event){
    arg.stopPropagation();
  }
  public onCheckClicked(index:number){
    //変更される前に呼び出される
    if (this.checked[index] && this.selectedId == index){
      //最寄りの行をアクティブ化
      var target = -1;
      this.checked.forEach((value,id) => {
        if (value && id != index && (target == -1 || Math.abs(id - index) < Math.abs(target - index))) target = id;
      });
      this.onCardClicked(target,false);
    } else if (this.checked[index] == false) {
      this.onCardClicked(index, false); //アクティブ状態をトリガー
    } else {
      //複数行選択の判定処理
      this.updateMultiSelection();
    }


  }
  //複数行選択判定プロパティ
  public multiSelection:boolean = false;  
  public updateMultiSelection(){
    this.$nextTick(()=>{
      if (this.checked.filter(obj=>obj).length == 1) this.multiSelection = false;
      else this.multiSelection = true;
    });    
  }
  public onCardClicked(index: number, autoCheck = false, clickEvent = false) {
    this.selectedId = index;
    this.$emit('selected', this.selectedId);

    if (autoCheck && this.checked[index] == false){
      for(var i = 0; i<this.checked.length;i++){
        if (i == index) this.$set(this.checked, i, true);
        else if(this.checked[i]) this.$set(this.checked, i, false);
      }
    }
    
    //複数行選択の判定処理
    this.updateMultiSelection();
    //spMode用にclickイベントを新設(エディタ切替に使用)
    if(clickEvent) this.$emit('click',index);
  }

  public fromIndex: number = 0;
  public toIndex: number = 0;

  public get selectedItems(): any[] {
    const targetList = new Array(0);
    this.items.forEach((obj, index) => {
      if (this.checked[index]) targetList.push(obj);
    });
    return targetList;
  } /**行を選択しスクロールします。 */

  public select(id: number, eventEnabled: boolean = true) {
    // スクロール実施～fromIndex/toIndexは一部しか見えていない状態があるのでスクロール必要な場合がある
    if (id <= this.fromIndex) {
      (this.$refs.listView as HTMLElement).scrollBy(0, -this.computeOffset(id, this.fromIndex));
    } else if (id >= this.toIndex) {
      (this.$refs.listView as HTMLElement).scrollBy(0, this.computeOffset(this.toIndex, id));
    } else {
      this.computeVisbleIndex();
    }
    // 選択処理
    if (eventEnabled) this.onCardClicked(id,true);
  }

  public computeOffset(from: number, to: number) {
    return this.rowHeight * (to - from + 1);
  }
  public resetChecked(){
      this.checked = new Array(this.items.length);
      this.allChecked = false;
      for (let i = 0; i < this.checked.length; i++) {
        this.checked[i] = false;
      }    
  }
  //#region バーチャルスクロール
  @Watch('items')
  public onValueChange(newValue: any[], oldValue: any[]): void {
    // コレクション変更後に呼び出されます(追加・編集・削除)
    // 初回はカードの高さを計測するため全項目を描画する

    if (newValue != oldValue) {
      this.checked = new Array(this.items.length);
      this.allChecked = false;
      for (let i = 0; i < this.checked.length; i++) {
        this.checked[i] = false;
      }

      if (this.$refs.listView) (this.$refs.listView as HTMLElement).scrollTo(0, 0);

      this.$nextTick(()=>this.setPaddingWidth()); //レコード数変更が即反映しない
      this.computeVisbleIndex();

      if (this.items.length > 0 && this.autoselect) this.onCardClicked(0,true);

    } else if(newValue.length > oldValue.length) {
      for (let i = 0; i < newValue.length - oldValue.length; i++) this.checked.splice(this.checked.length, null,false);  
      this.computeVisbleIndex();
    } else {
      this.computeVisbleIndex();      
    }
  }
  public updateChecked(index:number, value:boolean){
    this.$set(this.checked,index,value);
  }

  public onResize() {
    this.setPaddingWidth();
    this.computeVisbleIndex();
    this.$emit('endscrolled');    
  }

  public onScroll(event: any) {
    //ヘッダ側の水平スクロールを合わせる
    (this.$refs.listHead as HTMLElement).scrollTo((this.$refs.listView as HTMLElement).scrollLeft, 0);
    // マウスとコードによるスクロールを処理する
    this.computeVisbleIndex();

    //無限スクロール用にイベントを提供する
    var listView = this.$refs.listView as HTMLElement;
    if (listView.scrollTop + listView.clientHeight * 1.2 >= listView.scrollHeight ) this.$emit('endscrolled');
  }

  public computeVisbleIndex() {
    // 現在のスクロールポジションでfromIndex/toIndexを更新します。
    if (! this.$refs.listView)return;
    
    const ulRect = (this.$refs.listView as HTMLElement).getBoundingClientRect(); // 一つめの明細のスクロールトップを起点にする

    if (this.$refs.listCard == undefined) {
      this.fromIndex = 0;
      this.toIndex = ulRect.height / this.rowHeight;
      return;
    }
    const temp = (this.$refs.listCard as HTMLElement[]).map(obj => obj.getBoundingClientRect().top);
    let height = Math.min.apply(null, temp); //一つ目の明細のスクロールトップ

    //描画領域にあるインデックスを計算
    const margin = 5;
    this.toIndex = this.items.length - 1;
    for (let i = 0; i < this.items.length; i++) {
      //次の明細のtopが表示領域内にある場合にfromIndexをセットする
      if (height <= ulRect.top + margin && height + this.rowHeight > ulRect.top) {
        this.fromIndex = i;
      }
      //次の明細のtopが表示領域外にある場合にtoIndexをセットする
      if (height < ulRect.bottom && height + this.rowHeight >= ulRect.bottom - margin) {
        this.toIndex = i;
      }
      height += this.rowHeight;
    }
    this.$forceUpdate(); // virtualプロパティにバインドした場合と描画時間はそれほど変わらなかったので再描画する

    this.$nextTick(()=>{
      if(this.$api.formatter.hasPendingRequests && this.isFormatting == false) {
        this.isFormatting = true;
        //スクロール時は連続するので300ms 遅延させる
        window.setTimeout(()=>{
            this.isFormatting = false; //ここで保留状態を解除する
            this.$api.formatter.loadPendingLists().then(()=>{this.$forceUpdate();});
          }, 300);
      }
    });
  }
  public isFormatting = false;
  //#endregion

  //#region キースクロール

  public selectUp(event: any) {
    if (this.selectedId > 0) {
      this.select(this.selectedId - 1);
    }
    event.preventDefault();
  }

  public selectDown(event: any) {
    if (this.selectedId < this.items.length - 1) {
      this.select(this.selectedId + 1);
    }
    event.preventDefault();
  }

  public wheel(event: any) {
    // if (event.deltaY >0) this.selectDown(event);
    // else this.selectUp(event);
  }

  //#endregion
  public loadColumns() {
    //カラム固定位置(初期値2)
    var initialValue = (this.captions && this.captions.length > 2 && this.showGearButton && this.$api.spMode == false) ? 2: 0;
    this.stickyColumn = localStorage[this.storageKey + "_stickyColumn"] ? localStorage[this.storageKey + "_stickyColumn"] as number : initialValue;

    //columnsを初期化する
    let temp: Array<{ caption: string; width: number; position: number; visible: boolean; sortable: boolean }> = new Array();
    const setting = localStorage.getItem(this.storageKey);

    if (setting != null) temp = JSON.parse(setting);

    //初期非表示項目の追加〜未設定もしくは項目数が異なる場合は初期全表示として扱う
    var visibles:boolean[] = null;
    if (this.visibles && this.visibles.length == this.captions.length) visibles = this.visibles;
    else visibles = this.captions.map(o => true);

    //columnsは表示カラムを設定する
    this.captions.forEach((caption, index) => {
      const current = temp.find(obj => obj.caption == caption);
      const sortable = this.sortCaptions == null ? false : this.sortCaptions.findIndex(obj => obj == caption) != -1;
      if (current != null && current.visible) {
        //表示カラムを追加する
        this.columns.push({ caption: caption, width: this.widths[index] + current.width, position: index + current.position, slot: index, sortable: sortable });
      } else if (current == null && visibles[index]) {
        //初期表示の場合、新規カラムを追加する
        this.columns.push({ caption: caption, width: this.widths[index], position: index, slot: index, sortable: sortable });
      } else {
      }
    });
    //positionの昇順でソートする
    this.columns.sort((a, b) => a.position - b.position);
  }
  public saveColumns() {
    //columnsを保存する〜初期値から変更されていない場合は、システム設定を優先したいので、表示位置と表示幅の差分を保存する。
    const temp = new Array();
    this.captions.forEach((caption, index) => {
      const current = this.columns.find(obj => obj.caption == caption);
      if (current != null) {
        const currentIndex = this.columns.indexOf(current);
        //表示カラムを保存する
        temp.push({ caption: caption, width: current.width - this.widths[index], position: currentIndex - index, visible: true });
      } else {
        //非表示カラムを保存する
        temp.push({ caption: caption, width: 0, position: 0, visible: false });
      }
    });
    localStorage[this.storageKey] = JSON.stringify(temp);
    localStorage[this.storageKey + "_stickyColumn"] = this.stickyColumn;
  }

  private active = false;
  private offset = 0;
  private start = 0;
  private targetId = 0;
  private targetMode = '';
  private targetColumn: any = null;
  private targetDrag: HTMLElement = null;
  private selectorVisible = false;
  private columnVisiblities: Array<{ caption: string; visible: boolean }> = new Array();
  private paddingWidth: number = 0;
  private paddingWidthHeader: number = 0;

  //表示幅変更
  public onWidthChangeStart(e: any, index: number) {
    this.active = true;
    this.offset = 0;
    this.targetId = index;
    this.targetMode = 'width';
    this.targetColumn = this.columns[index];
    const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
    this.start = location.clientX;
    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }
  }

  public onMove(e: any) {
    //ドロップするまでの移動表示用にoffsetを更新する
    if (this.active) {
      const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
      this.offset += location.clientX - this.start;
      this.targetColumn.width += location.clientX - this.start;
      this.start = location.clientX;
      this.setPaddingWidth();

      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }
    }
  }
  public onMouseUp() {
    if (this.active) {
      this.active = false;
      this.saveColumns();
    }
  }
  private dragX: number;
  private dragY: number;
  private dragTarget: HTMLElement = null;
  private isModalDrag: boolean = false;
  public dragStart(index: number, e: any, isModalDrag:boolean = false) {
    if (this.active) {
      e.preventDefault();
      return;
    }
    this.isModalDrag = isModalDrag;
    this.targetId = index;
    //this.style.opacity = '0.4';  // this / e.target is the source node.

    // const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
    // this.dragX = location.clientX;
    // this.dragY = location.clientY;
    // this.dragTarget = e.currentTarget as HTMLElement;
  }

  public dragOver(index: number, e: any) {
    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }

    e.dataTransfer.dropEffect = 'move'; // See the section on the DataTransfer object.

    return false;
  }
  public dragMove(e: any) {
    // ドラッグ中のアイテムをカーソルの位置に追従
    var draggedElem = e.target;
    var touch = e.changedTouches[0];
    e.target.style.position = 'fixed';
    e.target.style.top = touch.clientY + window.scrollY - draggedElem.offsetHeight / 2 + 'px';
    e.target.style.left = touch.clientX + window.scrollX - draggedElem.offsetWidth / 2 + 'px';

    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }
  }
  public onTouchEnd(index: number, e: any) {
    //TouchEndはTouchStart時の要素に対して発生するのでドロップターゲットを自分で取得
    //data-item-idにindexを設定
    var droppedElem = e.target;
    droppedElem.style.position = '';
    e.target.style.top = '';
    e.target.style.left = '';
    var touch = e.changedTouches[0];
    var dropElement = document.elementFromPoint(touch.clientX, touch.clientY);
    const index2 = (dropElement.getAttribute('data-item-id') as any) as number;

    if(this.isModalDrag){
      const target = this.columnVisiblities[this.targetId];
      this.columnVisiblities.splice(this.targetId, 1);
      this.columnVisiblities.splice(index2, 0, target); 
    } else {
      const target = this.columns[this.targetId];
      this.columns.splice(this.targetId, 1);
      this.columns.splice(index2, 0, target); //前後どちらの移動もindex位置に挿入することになる
      this.saveColumns();
      this.$forceUpdate();
    }

  }
  public drop(index: number, e: any) {
    if (this.isModalDrag) {
      const target = this.columnVisiblities[this.targetId];
      this.columnVisiblities.splice(this.targetId, 1);
      this.columnVisiblities.splice(index, 0, target); 
    } else {
      const target = this.columns[this.targetId];
      this.columns.splice(this.targetId, 1);
      this.columns.splice(index, 0, target); //前後どちらの移動もindex位置に挿入することになる
      this.saveColumns();
      this.$forceUpdate();
    }

  }

  public tempStickyColumn:number = 0;
  public onShowSelector() {
    this.columnVisiblities = new Array();
    this.columns.forEach(column => {
      this.columnVisiblities.push({ caption: column.caption, visible: true });
    });
    this.captions.forEach(caption => {
      if (this.columns.findIndex(item => item.caption == caption) == -1) this.columnVisiblities.push({ caption: caption, visible: false });
    });
    this.tempStickyColumn = this.stickyColumn;
    this.selectorVisible = true;
  }
  public onOk(event: any) {

    if ((this.$refs.stickyColumn as any as Components.IControl).validator.validate() == false) {
      event.preventDefault();
      return;
    }

    this.stickyColumn = this.tempStickyColumn;
    //非表示を処理する
    this.columnVisiblities
      .filter(item => item.visible == false)
      .forEach(item => {
        let index = this.columns.findIndex(col => col.caption == item.caption);
        if (index != -1) this.columns.splice(index, 1);
      });
    //表示を処理する
    this.columns.splice(0,this.columns.length); //クリア
    this.columnVisiblities
      .filter(item => item.visible == true)
      .forEach(item => {
        // let index = this.columns.findIndex(col => col.caption == item.caption);
        let pos = this.captions.findIndex(caption => caption == item.caption);
        const sortable = this.sortCaptions == null ? false : this.sortCaptions.findIndex(obj => obj == item.caption) != -1;
        // if (index == -1) this.columns.push({ caption: item.caption, width: this.widths[pos], position: pos, slot: pos, sortable: sortable });
        this.columns.push({ caption: item.caption, width: this.widths[pos], position: pos, slot: pos, sortable: sortable });
      });
    this.saveColumns();
    this.setPaddingWidth();
    this.$forceUpdate();
  }

  public setPaddingWidth() {
      var el = this.$refs.listView as HTMLElement;
      if (el.clientHeight != 0){
        this.hasVerticalScrollbar =  el.scrollHeight  > el.clientHeight;
        // console.log('scrollbar: '+this.hasVerticalScrollbar + ' scrollHeight:' + el.scrollHeight + ' clientHeight:' + el.clientHeight);
      }

    //cssで対応済み
    // //テーブルサイズが領域より小さい場合にpaddingする
    // let totalWidth = 0;
    // let scrollGap = 0;
    // //縦スクロールバーがない状態で調整した後に縦スクロールバーが表示されると横スクロールバーが発生する。
    // if ((this.$refs.listView as HTMLElement).clientHeight < this.items.length * this.rowHeight) scrollGap = 17;

    // if (this.showCheckBox) totalWidth += 50;
    // this.columns.forEach(column => (totalWidth += column.width));
    // const temp = this.$el.clientWidth - scrollGap - totalWidth - 1;

    // if (scrollGap == 0) this.paddingWidth = temp > 40 ? temp : 40;
    // else this.paddingWidth = temp > 23 ? temp : 23;

    // this.paddingWidthHeader = this.paddingWidth;
    // if (scrollGap > 0) {
    //   this.paddingWidthHeader += 17;
    // }
  }

  public onSort(caption: string) {
    this.$emit('sort', caption);
  }
  
  stickyColumn:number = 2; //indexより1つ大きい値
  public getStickyStyle(index :number){
    var left = (index >=0 && this.showCheckBox ? 50 : 0) + this.columns.filter((obj, pos) =>pos < index).map(obj =>obj.width).reduce((sum, obj) => sum + obj,0);
    return index < this.stickyColumn ? "position:sticky; z-index:99; left:" + left + "px":""; 
  }
}
